import React from 'react'
import { Navigate } from 'react-router-dom'

import routePath from 'router/routePath'
import { useModuleConfig } from 'hooks/useModuleConfig/useModuleConfig'

type SaunaGateProps = {
  redirectTo?: string
  children: React.ReactElement
}

/**
 * Shows children only when sauna module is enabled in module config.
 */
export const SaunaGate: React.FC<SaunaGateProps> = ({
  children,
  redirectTo = routePath.notFound404,
}) => {
  const { sauna } = useModuleConfig()

  return sauna.enabled ? children : <Navigate to={redirectTo} replace />
}
